
import React from "react";

interface IconProps {
  className?: string; // className è opzionale e di tipo string
  icon?:string
}

export const IconBase: React.FC<IconProps> = ({ className,icon }) => (
  <svg
  viewBox="0 0 24 24"
  width="24"
  height="24"
  className={className}
  fill="none"
  stroke="currentColor"
  aria-hidden="true"
>
  
  {/* Freccia bianca proporzionata */}
  <path
  //  d="M6 10l6 6 6-6"
    d={icon} 
  
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
);
